import { useOrgId } from '@jira/router-resources__navigation-organization-id/src/useOrgId.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { useTeamsPermissionsService } from '@atlassian/teams-common/use-teams-permissions/main';
import type { TeamsPermissions } from '@atlassian/teams-common/teams-permission-store/types';

export const useTeamPermissions = (): TeamsPermissions => {
	const { data: orgId } = useOrgId();
	const { cloudId } = useTenantContext();

	const { permissions } = useTeamsPermissionsService(
		{
			orgId,
			cloudId,
		},
		{
			enabled: false,
		},
	);

	return permissions;
};
